module.exports = __webpack_public_path__ + "img/grain.a96311b4.webp";